'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require('./shared/propTypes');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Mark = function Mark(_ref) {
  var angle = _ref.angle,
      length = _ref.length,
      name = _ref.name,
      width = _ref.width,
      number = _ref.number;
  return _react2.default.createElement('div', {
    className: 'react-clock__mark react-clock__' + name + '-mark',
    style: {
      transform: 'rotate(' + angle + 'deg)'
    }
  }, _react2.default.createElement('div', {
    className: 'react-clock__mark__body react-clock__' + name + '-mark__body',
    style: {
      width: width + 'px',
      top: 0,
      bottom: 100 - length / 2 + '%'
    }
  }), number && _react2.default.createElement('div', {
    className: 'react-clock__mark__number',
    style: {
      transform: 'rotate(-' + angle + 'deg)',
      top: length / 2 + '%'
    }
  }, number));
};

Mark.defaultProps = {
  angle: 0,
  length: 10,
  width: 1
};
Mark.propTypes = {
  angle: _propTypes2.default.number,
  length: _propTypes3.isMarkLength,
  name: _propTypes2.default.string.isRequired,
  width: _propTypes3.isMarkWidth,
  number: _propTypes2.default.number
};
exports.default = Mark;